import type { GetAccountInfoServiceResponse } from '@musinsa/services-curator';
import type { SettlementFormData } from '../../settlement/components/SettlementInfoForm/types';

/**
 * Service Layer 응답을 Form defaultValues로 변환
 * API 데이터를 UI Form에 맞는 형태로 변환
 */
export const transformAccountInfoToFormData = (
  accountInfo: GetAccountInfoServiceResponse,
): Partial<SettlementFormData> => {
  const [idNumberFirst, idNumberSecond] = accountInfo.residentRegistrationNumber?.split('-') || [
    '',
    '',
  ];

  return {
    businessType: accountInfo.businessCategory,
    bankName: accountInfo.bankName,
    accountNumber: '',
    accountHolder: '',
    idNumberFirst,
    idNumberSecond,
    businessName: accountInfo.registeredBusinessName || '',
    businessRegistrationNumber: accountInfo.companyRegistrationNumber || '',
    identityFile: null,
    businessLicenseFile: null,
    accountCopyFile: null,
    isAccountVerified: true,
    termsAgreed: false,
  };
};
